import { type IngestType } from '@/features/shop/services/Orders/types'
import { queryOptions } from '@tanstack/react-query'
import { minutesToMilliseconds } from 'date-fns/minutesToMilliseconds'
import { getOrderKey } from '@/features/shop/services/Orders/keys'
import { fetchLastDeliveredOrder, fetchOrder } from '@/features/shop/services/Orders/fetchers'

export const lastDeliveredOrderQueryOptions = queryOptions({
  queryKey: ['Last delivered order'] as const,
  queryFn: fetchLastDeliveredOrder,
  staleTime: minutesToMilliseconds(15),
})

export const orderQueryOptions = (id: number, ingestType: IngestType) =>
  queryOptions({
    queryKey: getOrderKey(id, ingestType),
    queryFn: fetchOrder,
    staleTime: minutesToMilliseconds(15),
  })
